(() => {
  const teaserSelector = '.kl-teaser-X95rrq, .kl-teaser-T2rq8y';
  const buttonSelector = '.nutrise-sticky-cta.is-visible, [id^="ProductSubmitButton-"], .nh-closing-cta .product-form__submit';
  const mobile = window.matchMedia('(max-width: 749px)');
  const watched = new WeakSet();
  let frame = 0;

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(refresh);
  }

  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const stateObserver = new MutationObserver(schedule);

  function observe(element) {
    if (watched.has(element)) return;
    watched.add(element);
    if (resizeObserver) resizeObserver.observe(element);
    stateObserver.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'] });
  }

  function refresh() {
    frame = 0;
    const teasers = [...document.querySelectorAll(teaserSelector)];
    const buttons = [...document.querySelectorAll(buttonSelector)];
    document.querySelectorAll('.nutrise-sticky-cta').forEach(observe);
    teasers.forEach(observe);
    buttons.forEach(observe);

    if (!mobile.matches) {
      teasers.forEach((teaser) => {
        if (teaser.hasAttribute('data-nh-newsletter-clearance')) teaser.removeAttribute('data-nh-newsletter-clearance');
        if (teaser.style.getPropertyValue('--nh-newsletter-bottom')) teaser.style.removeProperty('--nh-newsletter-bottom');
      });
      return;
    }

    const viewportHeight = window.innerHeight;
    const blockers = buttons.map((button) => {
      const rect = button.getBoundingClientRect();
      const style = window.getComputedStyle(button);
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < viewportHeight &&
        style.display !== 'none' && style.visibility !== 'hidden' ? rect : null;
    }).filter(Boolean).sort((a, b) => b.top - a.top);

    teasers.forEach((teaser) => {
      const bounds = teaser.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const baseBottom = (parseFloat(teaser.style.bottom) || 0) + (parseFloat(teaser.style.marginBottom) || 0);
      let bottom = baseBottom;
      blockers.forEach((rect) => {
        const top = viewportHeight - bottom - bounds.height;
        const overlapsHorizontally = bounds.left < rect.right && bounds.right > rect.left;
        const overlapsVertically = top < rect.bottom + 12 && viewportHeight - bottom > rect.top - 12;
        if (overlapsHorizontally && overlapsVertically) bottom = Math.max(bottom, viewportHeight - rect.top + 12);
      });
      const value = Math.ceil(bottom) + 'px';
      if (teaser.style.getPropertyValue('--nh-newsletter-bottom') !== value) teaser.style.setProperty('--nh-newsletter-bottom', value);
      if (!teaser.hasAttribute('data-nh-newsletter-clearance')) teaser.setAttribute('data-nh-newsletter-clearance', '');
    });
  }

  function start() {
    const structureObserver = new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1))) schedule();
    });
    structureObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
